export const PAGE_CONFIG = {
  title: 'Rolling Retention',
  titleCN: '滚动留存',
  subTitle: '',
  subTitleCN: '',
  path: '/engagement/rollingRetention',
  defaultTab: 'newUsers',
  tabList: [
    {
      id: 'newUsers',
      tabName: 'Rolling Retention -New Users',
      tabNameCN: '新进用户滚动留存率',
      isHaveNotification: true,
      notificationPath: '/engagement/rollingRetention/newUsers',
      path: '/engagement/rollingRetention/newUsers',
      logConfig: {
        pageId: '205301',
        pageName: 'rollingRetentionNewUsers',
        extInfo: 'rollingRetentionNewUsers',
        pagePath: '/engagement/rollingRetention/newUsers',
      },
      filters: [
        {
          name: 'RollingRetentionFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/rollingRetention/newUsers',
          componentList: [
            {
              name: 'NightingaleLineChartCo',
              className: '',
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/rollingRetention/linechart',
                  componentMetrics: [
                    {
                      metricKey: 'd1',
                      reqMetricKey: 'd1',
                      enName: 'D1',
                      cnName: '次留',
                      rangeEnName: 'Average D1',
                      rangeCnName: '平均次留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d1',
                    },
                    {
                      metricKey: 'd2',
                      reqMetricKey: 'd2',
                      enName: 'D2',
                      cnName: '2留',
                      rangeEnName: 'Average D2',
                      rangeCnName: '平均2留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d2',
                    },
                    {
                      metricKey: 'd3',
                      reqMetricKey: 'd3',
                      enName: 'D3',
                      cnName: '3留',
                      rangeEnName: 'Average D3',
                      rangeCnName: '平均3留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d3',
                    },
                    {
                      metricKey: 'd7',
                      reqMetricKey: 'd7',
                      enName: 'D7',
                      cnName: '7留',
                      rangeEnName: 'Average D7',
                      rangeCnName: '平均7留',
                      type: 'percent',
                      decimal: 2,
                      avgResKey: 'avg_d7',
                    },
                  ],
                  title: 'D1/2/3/7 Rolling Retention -New Users',
                  titleCN: '新进用户滚动次留/2留/3留/7留',
                  isHaveTitle: true,
                  isHaveSubTitle: true,
                  enChartTooltipsName: 'New User Rolling Retention',
                  cnChartTooltipsName: '新进用户滚动留存',
                }
              },
              data: {
                tag: 'new_rolling',
              }
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/rollingRetention/table',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/rollingRetention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'New',
                      cnName: '注册',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Rolling Retention -New Users',
                  titleCN: '新进用户滚动留存率',
                }
              },
              data: {
                tag: 'new_rolling',
                retentionColumsNum:'1'
              }
            },
          ]
        },
      ],
    }
  ],
}